import { render, staticRenderFns } from "./EMStep1.vue?vue&type=template&id=904b80f4&scoped=true&"
import script from "./EMStep1.vue?vue&type=script&lang=js&"
export * from "./EMStep1.vue?vue&type=script&lang=js&"
import style0 from "./EMStep1.vue?vue&type=style&index=0&id=904b80f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904b80f4",
  null
  
)

export default component.exports